import { authHeader } from '../../_helpers';
import axios from 'axios';

export const customEmailService = {
    sendRemainderHandler,
    sendCustomMailHandler
};
axios.defaults.headers.common = authHeader();

function sendRemainderHandler(data) {
    return axios.post(`/assessments/custom/emails/send-remainder/`, data)
        .then(response => {
            return response;
        });
}

function sendCustomMailHandler(data) {
    return axios.post(`/assessments/custom/emails/send-custom-template/`, data)
        .then(response => {
            return response;
        })
}





// WEBPACK FOOTER //
// ./src/_services/customEmails/customEmail.service.js